import { constants, typographyStyles } from "@newsela/angelou";

const { circular } = typographyStyles.fontFamily;
const white = constants.colors.ui.white[50];

export const rootCss = () => [
  circular,
  {
    width: "100%",
    display: "flex",
    flexDirection: "column",

    svg: {
      marginTop: "16px",
      alignSelf: "center",
      fill: white,

      tspan: {
        fontWeight: "bold",
      },
    },
  },
];
